import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AuthState {
  token: string | null;
  username: string | null;
  role: string;
  mustChange: boolean;
  setAuth: (token: string, username: string, role?: string, mustChange?: boolean) => void;
  clearMustChange: () => void;
  logout: () => void;
}

/**
 * Operator session. Token persisted to localStorage so a reload keeps
 * the user logged in until the JWT expires (backend rejects expired
 * tokens → api.ts clears + redirects to /login).
 */
export const useAuth = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      username: null,
      role: 'editor',
      mustChange: false,
      setAuth: (token, username, role = 'editor', mustChange = false) =>
        set({ token, username, role, mustChange }),
      clearMustChange: () => set({ mustChange: false }),
      logout: () => set({ token: null, username: null, role: 'editor', mustChange: false }),
    }),
    { name: 'wiredesk-auth' },
  ),
);
